import * as React from 'react'
import { Link } from "gatsby"
import {fontColorWhite} from './shared.module.scss'

const CommunityBlockLink = ({title, path, image, height = false}) => {
    
    if(title.includes('Winter Park')){
      title = title.replace("Winter Park", "Winter\u00A0Park");
    }
  
    return (
        <div style={{background: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center', textAlign: 'center'}}>
            <div style={{
                display: 'flex', // Using Flexbox
                flexDirection: 'column', // Stack children vertically
                justifyContent: 'center', // Center vertically
                alignItems: 'center', // Center horizontally
                background: 'rgba(0,0,0,0.5)',
                height: height ? height : '100%',
                minHeight: '250px',
                maxHeight: height ? height : '250px',
                padding: '2rem',
                width: '100%'
            }} id="cblock_link_wrap" >
                <Link to={path} className={`community-block-link-${path}`}>
                    <h1 className={`${fontColorWhite} is-size-1`}>{title}</h1>
                    <h2 className={`${fontColorWhite} is-size-1`} style={{ fontFamily: "MoonTime" }}>Communities</h2>
                </Link>
            </div>
        </div>
    )
}

export default CommunityBlockLink
